/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : CustomFilesUploadButton.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */

import React, { useRef } from "react";
import PropTypes from "prop-types";
import CustomButtonV2 from "../customComponentsV2/common/button/CustomButtonV2";

function CustomFilesUploadButton({
  btnName,
  variant,
  size,
  disabled = false,
  btnStyle,
  onFilesSelected,
  multiple = true,
  startIcon,
  endIcon,
  accept,
}) {
  const inputRef = useRef();

  const handleButtonClick = () => {
    inputRef.current?.click();
  };

  const handleFileChange = (event) => {
    const files = event.target.files;
    if (files?.length) {
      onFilesSelected(files);
    }
    event.target.value = null;
  };

  return (
    <>
      <input
        type="file"
        ref={inputRef}
        onChange={handleFileChange}
        style={{ display: "none" }}
        multiple={multiple}
        accept={accept}
      />
      <CustomButtonV2
        variant="contained"
        btnName={btnName}
        size={size}
        handleOnClick={handleButtonClick}
        disabled={disabled}
        startIcon={startIcon}
        endIcon={endIcon}
        btnStyle={{
          textTransform: "none",
          fontWeight: 400,
          // fontSize: "0.500rem",
          borderRadius: 0,
          paddingY: 1,
          boxShadow:
            variant === "contained"
              ? "0px 2px 8px rgba(0, 0, 0, 0.15)"
              : "none",
          ...btnStyle,
        }}
      >
        {btnName}
      </CustomButtonV2>
    </>
  );
}

CustomFilesUploadButton.propTypes = {
  btnName: PropTypes.node,
  variant: PropTypes.string,
  size: PropTypes.string,
  disabled: PropTypes.bool,
  btnStyle: PropTypes.object,
  onFilesSelected: PropTypes.func,
  multiple: PropTypes.bool,
  startIcon: PropTypes.node,
  endIcon: PropTypes.node,
  accept: PropTypes.string,
};

CustomFilesUploadButton.defaultProps = {
  btnName: null,
  variant: undefined,
  size: undefined,
  disabled: false,
  btnStyle: {},
  onFilesSelected: () => {},
  multiple: true,
  startIcon: null,
  endIcon: null,
  accept: undefined,
};

export default CustomFilesUploadButton;

